// src/components/Footer.jsx
import React from 'react';

const Footer = () => {
  return (
    <footer className="portfolio-footer">
      <div className="footer-content">
        <div className="footer-left">
        </div>
        <div className="footer-right">
          <button onClick={() => window.open('https://calendly.com/ayoub-abdelouahabi/meeting', '_blank')}>
            Book Consultation
          </button>
          <p>© 2026 All rights reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;